import {useFields} from '../contexts/views/FieldsProvider'
import {useSetVisibleField, useVisibleFieldIdentifiers} from '../contexts/views/VisibleFieldsProvider'
import {FieldIdentifier} from './saved-view-options/fields'
import {SavedViewOptionsMenu} from './saved-view-options/SavedViewOptionsMenu'
import {useRepositorySavedViewOptions} from './use-repository-saved-view-options'

/**
 * Repository saved views still use the legacy split-ownership model: layout is URL-backed,
 * grouping is fixed to labels, and visibility comes from repository contexts. Once their
 * payload supplies baseline and applied configuration, migrate this adapter to
 * `SavedViewConfigurationProvider`, matching Planning.
 */
export function RepositorySavedViewOptionsMenu() {
  const {layout, setLayout} = useRepositorySavedViewOptions()
  const visibleFieldIdentifiers = useVisibleFieldIdentifiers()
  const setVisibleField = useSetVisibleField()
  const fields = useFields()

  return (
    <SavedViewOptionsMenu
      fields={fields}
      configuration={{
        layout,
        groupBy: FieldIdentifier.LABEL,
        swimlaneBy: null,
        sorts: [],
        visibleFields: [...visibleFieldIdentifiers],
      }}
      onLayoutChange={setLayout}
      onVisibleFieldChange={setVisibleField}
    />
  )
}
